module.exports = __webpack_public_path__ + "static/media/notification_Settings.f7feb16d.svg";